import { ButtonBase, Grid } from '@mui/material';
import { memo, useMemo } from 'react';
import ShaxmatkaHomeTooltip from '../tooltips/ShaxmatkaHomeTooltip';
import { Draggable, Droppable } from '@hello-pangea/dnd';

const Shaxmatka2Row = ({
  homesData,
  blockIndex,
  padezdIndex,
  floorNumber,
  isEditing,
  toggleSelectionItem = () => {},
  settingsMenuValue = '',
  maxPlace,
}) => {
  const homeList = useMemo(() => {
    const floorH = homesData?.filter((home) => home?.stage == floorNumber);
    const homes = new Array(maxPlace).fill(null);
    floorH.forEach((h, index) => {
      const place = h?.place ? h?.place - 1 : index;
      homes[place] = h;
    });
    return homes?.map((i, idx) =>
      i
        ? i
        : {
            id: `placeholder-${blockIndex}-${padezdIndex}-${floorNumber}-${idx}`, // STABIL ID
            isFree: true,
          }
    );
  }, [blockIndex, floorNumber, homesData, maxPlace, padezdIndex]);

  // const grouped = Object.values(
  //   homesData?.reduce((acc, item) => {
  //     if (!acc[item.stage]) {
  //       acc[item.stage] = [];
  //     }

  //     acc[item.stage].push(item);
  //     return acc;
  //   }, {})
  // );

  // const onClick = (item, index) => {
  //   if (floorNumber == 10) {
  //     grouped?.forEach((stages) => {
  //       const data = stages?.[index];
  //       if (data?.stage != 0)
  //         toggleSelectionItem(data.id, padezdIndex, blockIndex);
  //     });
  //   } else {
  //     toggleSelectionItem(item.id, padezdIndex, blockIndex);
  //   }
  // };

  return (
    <Droppable
      droppableId={`droppable-floor-${blockIndex}-${padezdIndex}-${floorNumber}`}
      direction='horizontal'
    >
      {(provided, snapshot) => (
        <Grid
          container
          rowSpacing={0}
          columns={{
            xs: parseInt(maxPlace),
            sm: parseInt(maxPlace),
          }}
          className={'sheet-home-row'}
          ref={provided.innerRef}
          {...provided.droppableProps}
        >
          {padezdIndex == 0 && (
            <Grid item sm={1} xs={1} className='sheet-home-cell !-ml-2.5 !mr-0'>
              <ButtonBase
                className='sheet-home-row-floor h-full w-8 text-sm font-medium !cursor-default'
                disableRipple
              >
                {floorNumber}
              </ButtonBase>
            </Grid>
          )}

          {homeList?.length > 0
            ? homeList.map((item, index) => {
                const keyBase = `block-${blockIndex}-${padezdIndex}-home`;
                return (
                  <Draggable
                    draggableId={`${item?.id}`}
                    index={index}
                    key={`${item?.id}`}
                    isDragDisabled={item?.isFree}
                  >
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <Grid
                          item
                          sm={1}
                          xs={1}
                          className={`sheet-home-cell floor-${floorNumber} `}
                          id={`${keyBase}-${item.id}`}
                          key={`${keyBase}-${item.id}`}
                        >
                          {item?.isFree ? (
                            // <ButtonBase
                            //   className={`block-${blockIndex}-${padezdIndex}-home home-item status-null `}
                            // />
                            <div
                              className={`block-${blockIndex}-${padezdIndex}-home home-item status-null `}
                            />
                          ) : (
                            <ShaxmatkaHomeTooltip
                              home={item}
                              disableFocusListener={isEditing}
                              disableHoverListener={isEditing}
                            >
                              <div
                                className={`block-${blockIndex}-${padezdIndex}-home home-item status-${
                                  item?.contract?.status == 2
                                    ? 'completed'
                                    : item?.status
                                }${item.disabled ? ' is-disabled' : ''}`}
                                id={`home-${item.id}`}
                                onClick={() =>
                                  // onClick(item, index)
                                  toggleSelectionItem(
                                    item.id,
                                    padezdIndex,
                                    blockIndex
                                  )
                                }
                              >
                                {settingsMenuValue === 'rooms' ? (
                                  !(item.stage && parseInt(item.stage) < 0) ? (
                                    item.rooms ? (
                                      <div>{item.rooms}x</div>
                                    ) : (
                                      ''
                                    )
                                  ) : (
                                    <div>P</div>
                                  )
                                ) : (
                                  <div>{item.number}</div>
                                )}
                              </div>
                            </ShaxmatkaHomeTooltip>
                          )}
                        </Grid>
                      </div>
                    )}
                  </Draggable>
                );
              })
            : [1].map((item) => (
                <Grid
                  item
                  sm={1}
                  xs={1}
                  key={`block-${blockIndex}-home-empty-${item}`}
                  id={`block-${blockIndex}-home-empty-${item}`}
                  className={`sheet-home-cell sheet-home-empty-cell floor-${floorNumber}`}
                >
                  <ButtonBase className='home-item is-empty'>
                    <div className='home-item-data'></div>
                  </ButtonBase>
                </Grid>
              ))}
          {provided.placeholder}
        </Grid>
      )}
    </Droppable>
  );
};

export default memo(Shaxmatka2Row);
